/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs */

const en_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move the Event position right 1 character`)
};

const fr_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer la position de l'evenement d'un caractere vers la droite`)
};

const de_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben Sie die Ereignisposition um ein Zeichen nach rechts.`)
};

const it_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la posizione dell'evento di 1 carattere a destra`)
};

const ru_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместите позицию события на один символ вправо.`)
};

const es_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mueva la posición del evento 1 carácter a la derecha`)
};

const zh_cn2_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将事件位置向右移动一个字符`)
};

const ja_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの位置を1文字右に移動する`)
};

const hi_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की स्थिति को 1 वर्ण दाएं ले जाएं`)
};

const pt_pt2_shortcut_keys_desc_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova a posição do evento um caractere para a direita.`)
};

/**
* | output |
* | --- |
* | "Move the Event position right 1 character" |
*
* @param {Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_move_right_one_character = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "de") return de_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "it") return it_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "es") return es_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_cc_move_right_one_character(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_cc_move_right_one_character(inputs)
	return en_shortcut_keys_desc_cc_move_right_one_character(inputs)
});